import http from "../http-common";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export const getPromotions = async () => {
  const response = await http.get("promotions");
  return response.data;
};

export const getPromotion = async (id) => {
  const response = await http.get(`promotions/${id}`);
  return response.data;
};

export const createPromotion = async (payload) => {
  const response = await http.post("promotions", payload);
  if (response.data.success) {
    toast.success(response.data.message || "Promotion created");
  } else {
    toast.error(response.data.message || "Failed to create promotion");
  }
  return response.data;
};

export const updatePromotion = async (id, payload) => {
  const response = await http.put(`promotions/${id}`, payload);
  if (response.data.success) {
    toast.success(response.data.message || "Promotion updated");
  } else {
    toast.error(response.data.message || "Failed to update promotion");
  }
  return response.data;
};

export const togglePromotion = async (id) => {
  const response = await http.put(`promotions/${id}/toggle`);
  if (response.data.success) {
    toast.success(response.data.message);
  } else {
    toast.error(response.data.message || "Failed to update promotion");
  }
  return response.data;
};

export const deletePromotion = async (id) => {
  const result = await Swal.fire({
    title: "Delete promotion?",
    text: "This will remove the promotion permanently.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it",
  });

  if (!result.isConfirmed) {
    return { cancelled: true };
  }

  const response = await http.delete("delete-promotion", { data: { id } });
  if (response.data.success) {
    toast.success(response.data.message || "Promotion deleted");
  } else {
    toast.error(response.data.message || "Failed to delete promotion");
  }
  return response.data;
};

export const searchProductsForPromotion = async (searchParam = "") => {
  const response = await http.get(
    `search?search=${encodeURIComponent(searchParam)}&page=1`
  );
  return response.data?.data || [];
};

export const getCategories = async () => {
  const response = await http.get("categories/product-categories");
  return Array.isArray(response.data) ? response.data : response.data?.data || [];
};
